export const ru = {
    'description-text':
        'Для товаров и услуг, которые подлежат обязательной сертификации, регистрации или лицензированию, нужно предоставить документы.',
    'one-banner-title-hint':
        'Рекомендация показывается, потому что для размещения объявления нужно предоставить документы',
    'send-lisence-letter': 'Отправить документы',
    'several-banners-title-hint':
        'Рекомендация показывается, потому что для размещения некоторых объявлений нужно предоставить документы',
    title: 'Отправьте документы для показа объявлений тематики «{theme}»'
};
